import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-addsibling",
  "use": "icon-addsibling-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-addsibling\">\n    <!-- Generator: Sketch 53.2 (72643) - https://sketchapp.com -->\n    <title>icon24/addsibling</title>\n    <desc>Created with Sketch.</desc>\n    <g id=\"icon-addsibling_icon24-symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"icon-addsibling_icon24/addsibling\" fill=\"#000000\">\n            <path d=\"M11,23 L11,13 L21,13 L21,23 L11,23 Z M17,17 L17,14 L15,14 L15,17 L12,17 L12,19 L15,19 L15,22 L17,22 L17,19 L20,19 L20,17 L17,17 Z\" id=\"icon-addsibling_Combined-Shape\" />\n            <path d=\"M11,11 L11,1 L21,1 L21,11 L11,11 Z M19,3 L13,3 L13,9 L19,9 L19,3 Z\" id=\"icon-addsibling_Shape\" />\n            <path d=\"M5,6 L5,18 L11,18 L11,20 L3,20 L3,18 L3,6 L3,4 L11,4 L11,6 L5,6 Z\" id=\"icon-addsibling_Combined-Shape\" />\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/addsibling.svg
// module id = WyzN
// module chunks = 54